export default __webpack_public_path__ + "static/media/power-plant.db65ca5d.png";